import "./ignore_reload.js";
import Vue from "vue";

// // jQuery
// import jQuery from "jquery";
// window.$ = jQuery;
// window.jQuery = jQuery;

// Array Polyfill
import "core-js/fn/array/from";

// Smooth Scroll
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// URL Polyfill
import "url-polyfill";

// babel/polyfill
import "@babel/polyfill";

// Font awesome
import "font-awesome/scss/font-awesome.scss";

// Custom Webfonts
import "./assets/scss/webfonts.scss";

// Custom CSS
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "tempusdominus-bootstrap-4/src/sass/tempusdominus-bootstrap-4-build.scss";
import "./assets/scss/style.scss";
import "./assets/scss/app.scss";
import "./assets/scss/reborn.scss";
import "./assets/scss/extends/refactoring.scss";

// Additional Component
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);

// Plugins
import AsteriaApi from "./plugins/AsteriaApi";
Vue.use(AsteriaApi, {
  apiUrl: process.env.VUE_APP_API_URL,
  submitUrl: process.env.VUE_APP_SUBMIT_URL,
  loginUrl: process.env.VUE_APP_LOGIN_URL,
  loginNittoUrl: process.env.VUE_APP_NITTO_LOGIN_URL,
  loginShiiresakiUrl: process.env.VUE_APP_SHIIRESAKI_LOGIN_URL
});

import BootstrapPlugin from "./plugins/Bootstrap";
Vue.use(BootstrapPlugin);

import DateFnsPlugin from "./plugins/date-fns";
Vue.use(DateFnsPlugin);

import DateTimePickerPlugin from "./plugins/DateTimePicker";
Vue.use(DateTimePickerPlugin);

import DownloadPlugin from "./plugins/Download";
Vue.use(DownloadPlugin);

import ObjectFitPlugin from "./plugins/ObjectFit";
Vue.use(ObjectFitPlugin);

import D3FormatPlugin from "./plugins/D3Format";
Vue.use(D3FormatPlugin);

import UtilityPlugin from "./plugins/Utility";
Vue.use(UtilityPlugin);

import PerfectScrollbarPlugin from "./plugins/PerfectScrollbar";
Vue.use(PerfectScrollbarPlugin);

import CommonHandlerPlugin from "./plugins/CommonHandler";
Vue.use(CommonHandlerPlugin);

// Bootstrap Components
import BootstrapModal from "./components/Bootstrap/Modal";
import BootstrapModalBackdrop from "./components/Bootstrap/ModalBackdrop";
import BootstrapLoading from "./components/Bootstrap/Loading";
import BootstrapPagination from "./components/Bootstrap/Pagination";
Vue.component("bs-modal", BootstrapModal);
Vue.component("bs-modal-backdrop", BootstrapModalBackdrop);
Vue.component("bs-loading", BootstrapLoading);
Vue.component("bs-pagination", BootstrapPagination);

// Global Components
import GlobalHeader from "./components/GlobalHeader";
import GlobalFooter from "./components/GlobalFooter";
import GlobalSideNav from "./components/GlobalSideNav";
import LabelInput from "./components/LabelInput";
import HeadMenu from "./components/HeadMenu";
import FileDrop from "./components/FileDrop";
import ErrorPage from "./components/Error";
import Privacy from "./components/Privacy";
Vue.component("global-header", GlobalHeader);
Vue.component("global-footer", GlobalFooter);
Vue.component("global-side-nav", GlobalSideNav);
Vue.component("label-input", LabelInput);
Vue.component("head-menu", HeadMenu);
Vue.component("file-drop", FileDrop);
Vue.component("error-page", ErrorPage);
Vue.component("privacy", Privacy);

Vue.config.productionTip = false;

/**マニュアルstyle*/
import "./assets/scss/instruction-manual.scss";

/**ND-net管理style*/
import "./assets/scss/admin/admin.scss";
import "./assets/scss/admin/admin_custom.scss";
import "element-ui/lib/theme-chalk/index.css";
import "vue-simple-suggest/dist/styles.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

/**ND-net管理コンポーネント*/
import "./assets/js/findindex-polyfill.js"; //IE11 support
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ja";
import VueQuillEditor from "vue-quill-editor";

Vue.use(ElementUI, { locale });
import "vue-simple-suggest/lib/polyfills"; //optional polyfills for IE11+
const VueSimpleSuggest = require("vue-simple-suggest/dist/cjs");
Vue.component("vue-simple-suggest", VueSimpleSuggest);
import Quill from 'quill';
var toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["clean"],
  ["link"]
];
Vue.use(VueQuillEditor, {
  modules: {
    toolbar: toolbarOptions,
    keyboard: {
      bindings: {
        list: {
          key: "backspace",
          context: { format: ["list"] },
          handler: function(range, context) {
            if (range.index === 0) return;
            if (range.length === 0) {
              this.quill.deleteText(range.index - 1, 1, Quill.sources.USER);
            } else {
              this.quill.deleteText(range, Quill.sources.USER);
            }
          }
        }
      }
    }
  }
});

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
